// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2JSnD","buttons":"SendReceipts_buttons__2tQSd","email":"SendReceipts_email__2-dnI","bookApptTitle":"SendReceipts_bookApptTitle__2lS7c"};